<div class="order-full-summary">
    <div class="order-full-summary__inner">

        <ng-container *ngIf="orderId">
            <shared-list-for-history-order-items [bottomPadding]="bottomPadding" [orderItems]="orderItems$ | async"
                [maxOnScreenHeight]="maxOnScreenHeight" class="order-full-summary__items">
            </shared-list-for-history-order-items>
        </ng-container>

        <ng-container *ngIf="transactionId">
            <shared-list-for-transaction-items [bottomPadding]="bottomPadding"
                [transaction]="transactionDetails$ | async" [maxOnScreenHeight]="maxOnScreenHeight"
                class="order-full-summary__items"></shared-list-for-transaction-items>
        </ng-container>

        <shared-order-summary [maxOnScreenHeight]="maxOnScreenHeight" class="order-full-summary__order-summary"
            [summary]="orderSummary$ | async" [paidWith]="paidWith" [voucher]="activeVoucher$ | async">
        </shared-order-summary>
    </div>
</div>
